__turbopack_context__.v({
  "card": "feature-card-module__Xnx0qa__card",
  "cta": "feature-card-module__Xnx0qa__cta",
  "desc": "feature-card-module__Xnx0qa__desc",
  "icon": "feature-card-module__Xnx0qa__icon",
  "label": "feature-card-module__Xnx0qa__label",
  "skeletonDesc": "feature-card-module__Xnx0qa__skeletonDesc",
  "skeletonStat": "feature-card-module__Xnx0qa__skeletonStat",
  "stat": "feature-card-module__Xnx0qa__stat",
  "statEmpty": "feature-card-module__Xnx0qa__statEmpty",
  "top": "feature-card-module__Xnx0qa__top",
});
